import { create } from 'zustand';

type Theme = 'light' | 'dark';

interface ThemeState {
    theme: Theme;
    toggleTheme: () => void;
    setTheme: (theme: Theme) => void;
}

const THEME_KEY = 'baywhiz-theme';

// Initialize theme from localStorage or default to dark
const getInitialTheme = (): Theme => {
    if (typeof window === 'undefined') return 'dark';
    const stored = localStorage.getItem(THEME_KEY);
    return (stored === 'light' || stored === 'dark') ? stored : 'dark';
};

/** Apply theme class to <html> — always removes both, then adds the correct one */
function applyThemeClass(theme: Theme) {
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(theme);
}

export const useTheme = create<ThemeState>((set) => ({
    theme: getInitialTheme(),

    toggleTheme: () => set((state) => {
        const newTheme = state.theme === 'dark' ? 'light' : 'dark';
        localStorage.setItem(THEME_KEY, newTheme);
        applyThemeClass(newTheme);
        return { theme: newTheme };
    }),

    setTheme: (theme: Theme) => set(() => {
        localStorage.setItem(THEME_KEY, theme);
        applyThemeClass(theme);
        return { theme };
    }),
}));

// Initialize theme class on module load — removes stale class first
if (typeof window !== 'undefined') {
    applyThemeClass(getInitialTheme());
}
